/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    [
      'ভোর', 'সকাল', 'দুপুর', 'বিকাল', 'সন্ধ্যা',
      'রাত্রি'
    ],
    ,
    [
      'ভোর', 'সকাল', 'দুপুর', 'বিকাল', 'সন্ধ্যা',
      'রাত্রিতে'
    ]
  ],
  [
    [
      'ভোর', 'সকাল', 'দুপুর', 'বিকাল', 'সন্ধ্যা',
      'রাত্রি'
    ],
    ,
  ],
  [
    ['04:00', '06:00'], ['06:00', '12:00'], ['12:00', '16:00'], ['16:00', '18:00'],
    ['18:00', '20:00'], ['20:00', '04:00']
  ]
];
